import React from 'react';

export function QuestionSkipped({ isDisabled, children }) {
    return <div className={isDisabled ? 'wrap-overlay-action cursor-disable' : ''} >
        {children}
    </div>;
}
